import { Injectable } from '@angular/core';
import { ApiService } from '@core/api.service';
import { Observable, of } from 'rxjs';
import {
  IShowcase,
  IShowcaseGroup
} from '@pages/dashboard/models/showcase.model';
import { map } from 'rxjs/internal/operators';
import { CachedRequestService } from '@app/core/service/cached-req.service';
import { IBanner, IBannerForm } from '../models/banner.model';

@Injectable()
export class ShowcaseService {
  constructor(
    private apiService: ApiService,
    private cachedRequestService: CachedRequestService,
  ) {}

  /**
   * Get showcase list data from API.
   * @returns {Observable<any>}
   */
  getShowcases(params: Record<string, string> = {}): Observable<IShowcase[]> {
    return this.apiService.get('/products/dashboard-items/items/', params).pipe(
      map(data => data.map(res => {
        res.showRealPicture = false;
        return res;
      }))
    );
  }

  getBanners(): Observable<IBanner[]> {
    return this.apiService.get('/products/banner-items/items/', { _ems_silenced: 'true' }).pipe(
      map(data => data.map(res => {
        res.showRealPicture = false;
        res.isLocalUrl = false;
        return res;
      }))
    );
  }

  getManageBanners(): Observable<IBanner[]> {
    return this.apiService.get('/products/banner-items/manage-items/', { _ems_silenced: 'true' }).pipe(
      map(data => data.map(res => {
        res.showRealPicture = false;
        res.isLocalUrl = false;
        return res;
      }))
    );
  }

  updateBannerField(id: number, field: string, value: string): Observable<IBanner> {
    return this.apiService.patch(`/products/banner-items/${id}/`, { [field]: value }).pipe(
      map(res => {
        res.showRealPicture = false;
        res.isLocalUrl = false;
        return res;
      })
    );
  }

  updateBanner (id: number, form: IBannerForm) {
    return this.apiService
      .put(`/products/banner-items/${id}/`, { ...form })
      .pipe(map(data => data));
  }

  createBanner( form: IBannerForm) {
    return this.apiService
      .post('/products/banner-items/', { ...form })
      .pipe(map(data => data));
  }
  /**
   * Post banner id on click
   * @param id
   * @returns {Observable<any>}
   */
  postBannerClick(id: number): Observable<any> {
    return this.apiService.post(`/products/banner-items/${id}/banner_click/`).pipe(map(data => data));
  }

  postDashboardClick(id: number): Observable<any> {
    return this.apiService.post(`/products/dashboard-items/${id}/dashboard_click/`).pipe(map(data => data));
  }

  getGroups(): Observable<IShowcaseGroup[]> {
    if (this.cachedRequestService.hasKeyAndNotExpired('cached-groups')) {
      return of(this.cachedRequestService.getItem('cached-groups'));
    } else {
      return this.apiService.get('/products/dashboard-groups/').pipe(
        map(data => {
          this.cachedRequestService.setItem(
            'cached-groups',
            data.results,
            Date.now() + 3600000,
          );
          return data.results;
        })
      );
    }
  }
}
